<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" label-width="100px" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="value8">
          <el-select v-model="form.sysId" clearable filterable placeholder="请选择业务系统">
            <el-option
              v-for="item in sysData"
              :key="item.systemId"
              :label="item.systemName"
              :value="item.systemId" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="form.ruleName" placeholder="请输入规则名称" clearable></el-input>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <div class="mv-list-buttons float-r">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            title="新增规则"
            @click="handleAdd"
          ></el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%;">
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="规则名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.ruleName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="验证码位数"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.codeDigit }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="有效时间(s)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.validateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="间隔时间(s)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.timeInterval }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="允许错误次数"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.codeCheckTimes }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="每日发送次数"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.accountSendTimes }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机锁定时间(h)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.accountLockTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="IP发送次数"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.ipSendTimes }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="IP锁定时间(h)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.ipLockTime }}</span>
          </template>
        </el-table-column>
        <el-table-column width="190" fixed="right" label="操作" >
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger"  @click="del(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog @close="closeRule" :title="ruleTitle"  width="570px" center :modal-append-to-body='false' :visible.sync="ruleDialog">
      <el-form :model="ruleInfo" :rules="ruleRule" ref="ruleInfo" label-width="140px">
        <el-form-item label="业务系统"  prop="sysId">
          <el-select
            v-model="ruleInfo.sysId"
            placeholder="请选择业务系统"
            style="width: 300px;"
            clearable
            :disabled="!add"
            filterable
          >
            <el-option
              v-for="(item, index) in sysData"
              :key="index"
              :label="item.systemName"
              :value="item.systemId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则名称" prop="ruleName"   >
          <el-input style="width: 300px;" placeholder="请输入规则名称" maxlength="32" clearable v-model="ruleInfo.ruleName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="规则状态" prop="ruleState">
          <el-radio-group v-model="ruleInfo.ruleState">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="验证码位数" prop="verificationNum">
          <el-input-number style="width: 300px;" v-model="ruleInfo.verificationNum"  :min="4" :max="6" ></el-input-number>
        </el-form-item>
        <el-form-item label="有效时间(s)" prop="effectiveTime">
          <el-input-number style="width: 300px;" v-model="ruleInfo.effectiveTime"  :min="60" :max="3000" ></el-input-number>
        </el-form-item>
        <el-form-item label="间隔时间(s)" prop="intervalTime">
          <el-input-number style="width: 300px;" v-model="ruleInfo.intervalTime"  :min="60" :max="300" ></el-input-number>
        </el-form-item>
        <el-form-item label="允许错误次数" prop="errorsNum">
          <el-input-number style="width: 300px;" v-model="ruleInfo.errorsNum"  :min="3" :max="5" ></el-input-number>
        </el-form-item>
        <el-form-item label="每日发送次数" prop="sendNum">
          <el-input-number style="width: 300px;" v-model="ruleInfo.sendNum"  :min="1" :max="100" ></el-input-number>
        </el-form-item>
        <el-form-item label="手机锁定时间(h)" prop="phoneLockTime">
          <el-input-number style="width: 300px;" v-model="ruleInfo.phoneLockTime"  :min="1" :max="24" ></el-input-number>
        </el-form-item>
        <el-form-item label="IP发送次数" prop="ipNum">
          <el-input-number style="width: 300px;" v-model="ruleInfo.ipNum"  :min="1" :max="100" ></el-input-number>
        </el-form-item>
        <el-form-item label="IP锁定时间(h)" prop="ipLockTime">
          <el-input-number style="width: 300px;" v-model="ruleInfo.ipLockTime"  :min="1" :max="24" ></el-input-number>
        </el-form-item>
        <el-form-item label="描述" >
          <el-input type="textarea" style="width: 300px;" maxlength="150" placeholder="请输入描述" v-model="ruleInfo.desc"></el-input>
        </el-form-item>
        <div style="text-align:center;">
          <el-button @click="ruleDialog=false">取 消</el-button>
          <el-button type="primary" v-show="add" @click="addSave('ruleInfo')">确 定</el-button>
          <el-button type="primary" v-show="!add" @click="editSave('ruleInfo')">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'codeRule',
  data () {
    return {
      form: {
        ruleName: '',
        sysId: ''
      },
      add: false,
      ruleTitle: '',
      ruleId: '',
      ruleInfo: {
        desc: '',
        ipLockTime: 24,
        ipNum: 20,
        phoneLockTime: 24,
        sendNum: 20,
        intervalTime: 120,
        effectiveTime: 300,
        errorsNum: 3,
        verificationNum: 6,
        ruleState: '0',
        ruleName: '',
        sysId: ''
      },
      ruleRule: {
        sysId: [
          {
            required: true,
            message: '请选择业务系统',
            trigger: ['blur', 'change']
          }
        ],
        ruleName: [
          { required: true, message: '请输入规则名称', trigger: ['blur', 'change'] },
          { min: 1, max: 32, message: '长度在1至32个字符', trigger: ['blur', 'change'] }
        ],
        ruleState: [
          {
            required: true,
            message: '请选择规则状态',
            trigger: ['blur', 'change']
          }
        ],
        verificationNum: [
          {
            required: true,
            message: '请输入验证码位数',
            trigger: ['blur', 'change']
          }
        ],
        errorsNum: [
          {
            required: true,
            message: '请输入错误次数',
            trigger: ['blur', 'change']
          }
        ],
        effectiveTime: [
          {
            required: true,
            message: '请输入有效时间',
            trigger: ['blur', 'change']
          }
        ],
        intervalTime: [
          {
            required: true,
            message: '请输入间隔时间',
            trigger: ['blur', 'change']
          }
        ],
        sendNum: [
          {
            required: true,
            message: '请输入每日发送次数',
            trigger: ['blur', 'change']
          }
        ],
        phoneLockTime: [
          {
            required: true,
            message: '请输入手机锁定时间',
            trigger: ['blur', 'change']
          }
        ],
        ipNum: [
          {
            required: true,
            message: '请输入IP发送次数',
            trigger: ['blur', 'change']
          }
        ],
        ipLockTime: [
          {
            required: true,
            message: '请输入IP锁定时间',
            trigger: ['blur', 'change']
          }
        ]
      },
      sysData: [],
      ruleDialog: false,
      tableData: [],
      detailForm: {},
      tooltip: true,
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.ruleName = ''
      this.form.sysId = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    handleAdd () {
      this.add = true
      this.ruleTitle = '新增验证码规则'
      this.ruleDialog = true
    },
    handleEdit (index, val) {
      this.add = false
      this.ruleId = val.ruleId
      this.ruleInfo.sysId = Number(val.sysId)
      this.ruleInfo.ruleName = val.ruleName
      this.ruleInfo.ruleState = val.ruleStatus + ''
      this.ruleInfo.verificationNum = val.codeDigit
      this.ruleInfo.errorsNum = val.codeCheckTimes
      this.ruleInfo.effectiveTime = val.validateTime
      this.ruleInfo.intervalTime = val.timeInterval
      this.ruleInfo.sendNum = val.accountSendTimes
      this.ruleInfo.phoneLockTime = val.accountLockTime
      this.ruleInfo.ipNum = val.ipSendTimes
      this.ruleInfo.ipLockTime = val.ipLockTime
      this.ruleInfo.desc = val.ruleDesc
      this.ruleTitle = '编辑验证码规则'
      this.ruleDialog = true
    },
    addSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let id = this.ruleInfo.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          op.sysIds = sysIds
          op.ruleName = _this.ruleInfo.ruleName
          op.ruleStatus = _this.ruleInfo.ruleState
          op.codeDigit = _this.ruleInfo.verificationNum
          op.codeCheckTimes = _this.ruleInfo.errorsNum
          op.validateTime = _this.ruleInfo.effectiveTime
          op.timeInterval = _this.ruleInfo.intervalTime
          op.accountSendTimes = _this.ruleInfo.sendNum
          op.accountLockTime = _this.ruleInfo.phoneLockTime
          op.ipSendTimes = _this.ruleInfo.ipNum
          op.ipLockTime = _this.ruleInfo.ipLockTime
          op.ruleDesc = _this.ruleInfo.desc
          _this.$axios({
            url: _this.$API.rechargeManagement.addVerificationCodeRule,
            // url: 'http://172.16.9.73:5010/agw/verificationCodeRuleCtr/addVerificationCodeRule',
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('验证码规则新增成功!')
            _this.ruleDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    editSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let id = this.ruleInfo.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          op.ruleId = _this.ruleId
          op.sysIds = sysIds
          op.ruleName = _this.ruleInfo.ruleName
          op.ruleStatus = _this.ruleInfo.ruleState
          op.codeDigit = _this.ruleInfo.verificationNum
          op.codeCheckTimes = _this.ruleInfo.errorsNum
          op.validateTime = _this.ruleInfo.effectiveTime
          op.timeInterval = _this.ruleInfo.intervalTime
          op.accountSendTimes = _this.ruleInfo.sendNum
          op.accountLockTime = _this.ruleInfo.phoneLockTime
          op.ipSendTimes = _this.ruleInfo.ipNum
          op.ipLockTime = _this.ruleInfo.ipLockTime
          op.ruleDesc = _this.ruleInfo.desc
          _this.$axios({
            url: _this.$API.rechargeManagement.editVerificationCodeRule,
            // url: 'http://172.16.9.73:5010/agw/verificationCodeRuleCtr/editVerificationCodeRule',
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('验证码规则编辑成功!')
            _this.ruleDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    del (index, row) {
      let op = {}
      let _this = this
      op.ruleId = row.ruleId
      this.$confirm('确认是否删除验证码规则?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          url: _this.$API.rechargeManagement.delVerificationCodeRule,
          // url: 'http://172.16.9.73:5010/agw/verificationCodeRuleCtr/delVerificationCodeRule',
          method: 'post',
          data: op
        }).then((response) => {
          _this.query()
          _this.$message.success('验证码规则删除成功')
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    closeRule () {
      this.ruleInfo = {
        desc: '',
        ipLockTime: 24,
        ipNum: 20,
        phoneLockTime: 24,
        sendNum: 20,
        intervalTime: 120,
        effectiveTime: 300,
        errorsNum: 3,
        verificationNum: 6,
        ruleState: '0',
        ruleName: '',
        sysId: ''
      }
      this.ruleId = ''
      this.add = false
      this.$refs['ruleInfo'].resetFields() // 关闭时清除验证条件
      this.ruleDialog = false
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.ruleName = this.form.ruleName
      op.sysIds = sysIds
      this.$axios({
        url: _this.$API.rechargeManagement.queryVerificationCodeRuleListByPage,
        // url: 'http://172.16.9.73:5010/agw/verificationCodeRuleCtr/queryVerificationCodeRuleListByPage',
        method: 'post',
        data: op
      }).then((response) => {
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    let _this = this
    let op = {}
    op.pageNum = 1
    op.pageSize = 100
    this.$axios({
      url: _this.$API.apiList.oldquerySysList,
      method: 'post',
      data: op
    }).then((response) => {
      console.log(response)
      _this.sysData = response.data.resData.data
    }).catch((err) => {
      console.log(err)
    })
    this.query()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/userManagement/codeRule.vue